// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="explore-page">Explore Page</h2>
      <p>Check out our Swagger Docs for Available APIs</p>
    </div>
  );
};

export default MarkdownComponent;
